<template>
  <div>
      <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow': visible }"
    :style="visible ? 'display:block;' : ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <b>Chat:</b>
            {{ chat.isSender ? chat.receiver.username : chat.sender.username }}
          </h5>
          <span v-if="ticketEmit" class="btn btn-success ml-auto">Reclamo iniciado</span>
          <span v-else class="btn btn-danger ml-auto" @click="handleShowInitClaim">Iniciar reclamo</span>
          <button
            type="button"
            class="close ml-0"
            data-dismiss="modal"
            aria-label="Close"
            @click="handleCloseModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body mt-4">
          <div class="chat-container">
            <div
              v-for="aMessage in chat.messages"
              :key="aMessage._id"
              class="item-chat"
              :class="aMessage.sender == chat.isSender ? 'sender' : 'receiver'"
            >
              <div class="chat">{{ aMessage.message }}
                <span  v-show="aMessage.method.type && aMessage.sender != chat.isSender && aMessage.method.accepted" class="badge badge-success">Pagado</span>
                <span v-show="aMessage.method.type && aMessage.sender == chat.isSender && aMessage.method.accepted" class="badge badge-success">Pagado</span>
                <span v-show="aMessage.method.type && aMessage.sender == chat.isSender && !aMessage.method.accepted" class="badge badge-warning">Pendiente de pago</span>
                <span v-show="hasPay" class="badge badge-success">Pagado</span>
                <div v-show="aMessage.method.type && !aMessage.method.accepted && aMessage.sender != chat.isSender" class="my-3">
                  <p class="alert alert-danger" v-show="!hasPay">Al hacer click en pagar se le depositará  {{askPrice(aMessage.method.amount, aMessage.method.currency)}} al vendedor </p>
                  <p class="text-right">
                    <span v-show="!onLoadPay && !hasPay" class="btn btn-treid" @click="handleClickPay(aMessage._id)">Pagar</span>
                    <span v-show="onLoadPay && !hasPay" class="btn btn-treid">Pagando...</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col">
              <textarea
                v-model="message"
                type="text"
                class="form-control"
                placeholder="mensaje..."
                v-on:keyup.enter="handleSendMessage"
                rows="3"
              ></textarea>
            </div>
            <div class="col-auto d-flex align-items-center">
              <span
                class="material-icons btn btn-treid"
                @click="handleSendMessage"
              >
                send
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ModalConfirmTicket v-on:close="handleCloseConfirmTicket" v-on:accept="handleConfirmTicket" :visible="modalConfirmTicket.visible" :load="modalConfirmTicket.load" />
  </div>
</template>
<script>
import Api2 from "../../tools/Api2";
import ModalConfirmTicket from './ModalConfirmTicket.vue'
import { LC } from "../../tools/exchange";
export default {
  name: "ModalChatSale",
  components:{
    ModalConfirmTicket
  },
  props: {
    visible: Boolean,
    buy: String,
    claim: Boolean
  },
  data() {
    return {
      hasPay: false,
      onLoadPay: false,
      localCurrency: null,
      ticketEmit: false,
      message: "",
      chat: {
        _id: 0,
        receiver: {
          username: "",
        },
        sender: {
          username: "",
        },
        messages: [],
      },
      modalConfirmTicket: {
        visible: false,
        load: false
      }
    };
  },
  watch: {
    visible: function(){
            setTimeout(() => {
              const chatContainer = document.querySelector(".chat-container");
      chatContainer.scrollTop = chatContainer.scrollHeight;
            }, 100);
    }
  },
  methods: {
    askPrice: function(price, currency) {
      if (this.localCurrency)
        return "$SC "+this.localCurrency
          .localToSC({ price: price, currency: currency })
          .toFixed(2);
      return -1;
    },
    handleClickPay(message) {
      this.onLoadPay = true;
      Api2(`chat/${this.chat._id}/${message}`).post().finally(() => {
        this.onLoadPay = false;
        this.hasPay = true;
      });
    },
    handleCloseModal() {
      this.$emit("close");
    },
    handleSendMessage() {
      Api2("chat").patch(this.chat._id, {
        message: this.message,
      });
      this.chat.messages.push({
        _id: Math.random(),
        message: this.message,
        sender: this.chat.isSender,
      });
      this.message = "";
           setTimeout(() => {
              const chatContainer = document.querySelector(".chat-container");
      chatContainer.scrollTop = chatContainer.scrollHeight;
            }, 100);
    },
    handleCloseConfirmTicket(){
      this.modalConfirmTicket.visible = false;
    },
    handleConfirmTicket(){
      this.modalConfirmTicket.load = true;
      Api2("buy/claim").patch(this.buy, {claim: true}).then(() => {
        this.modalConfirmTicket.load = false;
        this.ticketEmit = true;
        this.modalConfirmTicket.visible = false;
      })
    },
    handleShowInitClaim(){
      this.modalConfirmTicket.visible = true;
    }

  },
  created: function () {
        LC.new().then((localCurrency) => {
      this.localCurrency = localCurrency;
    });
    this.ticketEmit = this.claim;
    Api2("chat/buy")
      .get(this.buy)
      .then((res) => {
        this.chat = {
          ...res.chat,
          messages: res.messages,
          isSender: res.isSender,
        };
      });
  },
};
</script>
<style lang="css" scoped>
.chat-container {
  overflow-y: auto;
  max-height: 400px !important;
  height: 400px;
}
.item-chat {
  margin-bottom: 1em;
  display: flex;
}
.item-chat.new {
  justify-content: center !important;
  margin: 0 10%;
  border-top: 1px solid grey;
}

.item-chat.new > .chat {
  padding: 0.5em;
}

.item-chat.sender {
  padding-left: 1em;
  flex-direction: row-reverse !important;
  text-align: right;
}
.item-chat.sender {
  padding-right: 1em;
}

.item-chat.sender > .chat {
  padding: 0.5em;
  border-radius: 0.3em;
  color: white;
  background-color: #3a567f;
}

.item-chat.receiver > .chat {
  padding: 0.5em;
  background-color: #f1f0f0;
  border-radius: 0.3em;
}
</style>